import http from "@/common/http.service";
const ROOT_URL = "sender/list";
const DELETE_URL = "sender/delete";
const VERIFY_URL = "sender/verify-email";
const DETAILS_URL = "sender/get-details";
const USER_SAVE = "sender/save";
export default {
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then(function (response) {
      var data = { items: response.data.data, total: response.data.totalRows };
      cb(data);
    });
  },

  delete(id) {
    return http.post(DELETE_URL, { id: id });
  },
};

export const saveSender = (params) => {
  return http.post(USER_SAVE, params);
};

export const verifyEmail = (id) => {
  return http.post(VERIFY_URL, { id: id });
};

export const getDetails = (id) => {
  return http.post(DETAILS_URL, { id: id });
};
